import React from "react"
import { Calendar, CalendarProps } from "react-big-calendar"
import "react-big-calendar/lib/css/react-big-calendar.css"
import dayjsLocalizer from "utils/dayjsLocalizer"
import "./styles.scss"
export type BigCalendarType = Omit<CalendarProps, "localizer"> & {}

const BigCalendar = ({ ...props }: BigCalendarType) => {
  return <Calendar localizer={dayjsLocalizer} {...props} />
}

BigCalendar.defaultProps = {
  startAccessor: "start",
  endAccessor: "end",
}
export default BigCalendar
